import { Component, Input } from '@angular/core';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';
import { LibraryUserPickerTableComponent } from '../../controls/user-picker-table/user-picker-table.component';

@Component({
  selector: 'app-available-libraries-list',
  templateUrl: './available-libraries-list.component.html',
  styleUrls: ['./available-libraries-list.component.sass']
})
export class AvailableLibrariesListComponent extends BaseListDirective {
  @Input() containerStyleClass = "h-full"
  @Input() horizontal = false

  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('name_', 'FORM.TITLE', 150, { frozen: true }),
    new PrimeNGTableColumn('description_', 'FORM.DESCRIPTION', 300),
    new PrimeNGTableColumn('tags', 'FORM.TAGS', 200)
  ];
  override title = 'MENU.LIBRARIES';
  override filterableFields = ['name_', 'description_', 'tags']
  override keys = {
    primary_key: 'library_id',
    label: 'name_'
  }
  override filename = 'MENU.LIBRARIES';
  override orderKey = "name_"

  override formatData(data: any): void {
    this.utils.applyLibraryFormat(data)
  }

  override getList(): void {
    this.query(this.data.core.libraries()).subscribe()
  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.libraryDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }

  seeUsers(row: any) {
    const header = this.utils.translate.instant(
      'FORM.AVAILABLE-USERS-IN-X', {
      value: row.name_
    })
    this.dialog.open(LibraryUserPickerTableComponent, {
      header,
      width: '80%',
      height: '100%',
      styleClass: 'p-overflow-hidden',
      contentStyle: { height: '100%', overflow: 'hidden', padding: '.3rem' },
      data: {
        parentId: row.library_id
      }
    })
  }
}
